import { notification } from "antd";
import { memo, useCallback, useEffect, useState } from "react";

import {
    StyledFlashButton,
    StyledFlashIconOff,
    StyledFlashIconOn,
} from "./Styled";

interface FlashControlProps {
    stream: MediaStream | null;
    isReady: boolean;
}

export const FlashControl = memo(({ stream, isReady }: FlashControlProps) => {
    const [torchOn, setTorchOn] = useState(false);
    const [torchSupported, setTorchSupported] = useState(false);

    useEffect(() => {
        if (!isReady || !stream) return;

        const track = stream.getVideoTracks()[0];
        if (!track) return;

        const caps = track.getCapabilities() as MediaTrackCapabilities & {
            torch?: boolean;
        };

        setTorchSupported(!!caps.torch);
        setTorchOn(false);
    }, [isReady, stream]);

    const toggleFlash = useCallback(async () => {
        if (!stream || !torchSupported) return;

        const track = stream.getVideoTracks()[0];
        if (!track) return;

        const next = !torchOn;

        try {
            await track.applyConstraints({
                advanced: [{ torch: next } as MediaTrackConstraintSet],
            });
            setTorchOn(next);
        } catch (e) {
            console.warn("Torch toggle failed:", e);
            notification.error({ message: "Спалах недоступний" });
        }
    }, [stream, torchOn, torchSupported]);

    if (!isReady) return null;

    return (
        <StyledFlashButton
            $on={torchOn}
            $supported={torchSupported}
            onClick={toggleFlash}
            title={torchOn ? "Вимкнути спалах" : "Увімкнути спалах"}
        >
            {torchOn ? <StyledFlashIconOn /> : <StyledFlashIconOff />}
        </StyledFlashButton>
    );
});

FlashControl.displayName = "FlashControl";
